export default function TopBanner() {
  return (
    <div className="bg-[#062133] text-white py-2 px-4 text-center" data-testid="top-banner">
      <p className="text-xs sm:text-sm font-medium tracking-wide">
        Intervention rapide en Suisse romande &bull; <a href="tel:+41245391033" className="underline hover:text-white/80">024 539 10 33</a> &bull; Note 5&#9733; &bull; +500 interventions
      </p>
    </div>
  );
}
